import { AfterViewInit, Component } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Hub, ConsoleLogger as Logger } from 'aws-amplify/utils';
import { AuthSession } from '../../models/profile';
import { first } from 'rxjs';
import { SpinnerComponent } from '../../../../shared/components/spinner/spinner.component';

const logger = new Logger('AzWebAppLogger');

@Component({
    selector: 'app-callback',
    imports: [SpinnerComponent],
    templateUrl: './callback.component.html',
    styleUrl: './callback.component.scss'
})
export class CallbackComponent implements AfterViewInit {
  authToken: AuthSession | undefined;
  error = '';
  code = '';
  constructor(
    private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    Hub.listen('auth', (data) => {
      const { payload } = data;
      this.onAuthEvent(payload);
    });
  }

  ngAfterViewInit(): void {
    // if it comes to this point when loggged then redirect to guadalajara
    this.authService
      .getUserBySession()
      .pipe(first())
      .subscribe((user) => {
        if (user) {
          this.router.navigate(['/auth/redirect']);
        }
      });

    this.route.queryParams.subscribe((params) => {
      this.error = params['error'];
      this.code = params['code'];
      if (this.error) {
        console.log(this.error);
      }
      if (this.code) {
        this.navigateToDashboard();
      }
    });
  }

  navigateToDashboard() {
    this.authService
      .getUserBySession()
      .pipe(first())
      .subscribe((user) => {
        console.log('User by session: ', JSON.stringify(user));
        if (user) {
          this.router.navigate(['/auth/redirect']);
        } else {
          this.router.navigate(['/auth/login']);
        }
      });
  }

  onAuthEvent(payload: any) {
    switch (payload?.event) {
      case 'configured':
        logger.info('Az: the Auth module is configured');
        break;
      case 'signIn':
        logger.info('Az: user signed in');
        break;
      case 'signIn_failure':
        logger.error('Az: user sign in failed');
        break;
      case 'signUp':
        logger.info('Az: user signed up');
        break;
      case 'signUp_failure':
        logger.error('Az: user sign up failed');
        break;
      case 'confirmSignUp':
        logger.info('Az: user confirmation successful');
        break;
      case 'completeNewPassword_failure':
        logger.error('Az: user did not complete new password flow');
        break;
      case 'autoSignIn':
        logger.info('Az: auto sign in successful');
        break;
      case 'autoSignIn_failure':
        logger.error('Az: auto sign in failed');
        break;
      case 'forgotPassword':
        logger.info('Az: password recovery initiated');
        break;
      case 'forgotPassword_failure':
        logger.error('Az: password recovery failed');
        break;
      case 'forgotPasswordSubmit':
        logger.info('Az: password confirmation successful');
        break;
      case 'forgotPasswordSubmit_failure':
        logger.error('Az: password confirmation failed');
        break;
      case 'verify':
        logger.info('Az: TOTP token verification successful');
        break;
      case 'tokenRefresh':
        logger.info('Az: token refresh succeeded');
        break;
      case 'tokenRefresh_failure':
        logger.error('Az: token refresh failed');
        break;
      case 'cognitoHostedUI':
        logger.info('Az: Cognito Hosted UI sign in successful');
        this.navigateToDashboard();
        break;
      case 'cognitoHostedUI_failure':
        logger.error('Az: Cognito Hosted UI sign in failed');
        break;
      case 'customOAuthState':
        logger.info('Az: custom state returned from CognitoHosted UI');
        break;
      case 'customState_failure':
        logger.error('Az: custom state failure');
        break;
      case 'parsingCallbackUrl':
        logger.info('Az: Cognito Hosted UI OAuth url parsing initiated');
        break;
      case 'userDeleted':
        logger.info('Az: user deletion successful');
        break;
      case 'updateUserAttributes':
        logger.info('Az: user attributes update successful');
        break;
      case 'updateUserAttributes_failure':
        logger.info('Az: user attributes update failed');
        break;
      case 'signOut':
        logger.info('Az: user signed out');
        break;
      default:
        logger.info('Az: unknown event type');
        break;
    }
  }
}
